import type { Order } from "./types";

/** IVA sugli acquisti dai fornitori italiani. ``supplier_cost`` è il NETTO
 *  (imponibile): il bonifico si fa sul lordo. Stessa costante del backend
 *  (``wp_shop_service._VAT_MULTIPLIER``). */
const IVA = 1.22;

export type BonificoSelezione = {
  /** Somma IVA INCLUSA dei soli ordini di cui conosciamo il costo. */
  totaleLordo: number;
  /** Quanti ordini hanno contribuito al totale. */
  conCosto: number;
  /** Quanti ordini selezionati NON hanno un costo noto: non sono nel totale. */
  senzaCosto: number;
  /** I numeri ordine fornitore della selezione, senza «ITYH-»: vanno nella
   *  causale del bonifico (Davide 28/09). Chi non ce l'ha non compare. */
  numeri: string[];
};

/**
 * Quanto c'è da bonificare al fornitore per gli ordini selezionati.
 *
 * Il costo d'acquisto arriva dalla mail di conferma del fornitore (o
 * dall'ordine creato da OM sul portale) ed è NETTO: qui si moltiplica per
 * l'IVA perché il bonifico si fa sul lordo.
 *
 * Gli ordini senza costo noto **non vengono contati come zero**: restano
 * fuori dal totale e vengono dichiarati a parte. Un totale che ingloba
 * silenziosamente gli sconosciuti è un totale sbagliato che sembra giusto.
 */
export function bonificoSelezione(orders: readonly Order[]): BonificoSelezione {
  let netto = 0;
  let conCosto = 0;
  for (const o of orders) {
    // ``costoNoto`` assente = fixture/mock legacy: ci si affida al costo > 0.
    const noto = o.costoNoto ?? o.costo > 0;
    if (!noto) continue;
    netto += o.costo;
    conCosto += 1;
  }
  return {
    totaleLordo: Math.round(netto * IVA * 100) / 100,
    conCosto,
    senzaCosto: orders.length - conCosto,
    numeri: orders
      .map((o) => (o.supplierOrderRef ?? "").trim().replace(/^ITYH-/i, ""))
      .filter(Boolean),
  };
}
